import React from "react";
import { Link } from "react-router-dom";

interface Props {
    link: string;
    label: string;
    direct?: boolean;
    bold?: boolean;
    collapse: () => void;
}

const NavigationLink: React.FC<Props> = ({ link, label, direct, bold, collapse }) => {
    const labelContent = bold ? <strong>{label}</strong> : <span>{label}</span>;

    if (direct) {
        return (
            <li className="sidebar-navigation-list-item">
                <a
                    href={link}
                    className="sidebar-navigation-list-item-link"
                    onClick={collapse}
                >
                    {labelContent}
                </a>
            </li>
        );
    }

    return (
        <li className="sidebar-navigation-list-item">
            <Link
                to={link}
                className="sidebar-navigation-list-item-link"
                onClick={collapse}
            >
                {labelContent}
            </Link>
        </li>
    );
};

export default NavigationLink;
